import { z } from "zod"
import { baseSchema, schemaToJson } from "../schema-utils.js"

const DbBookmarkSchema = z.strictObject({
  ...baseSchema.shape,
  story_id: z.string(),
  user_id: z.string(),
  bookmarked_at: z.date(),
  bookmarked_iso: z.iso.date(),
})
export type DbBookmark = z.infer<typeof DbBookmarkSchema>

export const BookmarkSchema = schemaToJson(DbBookmarkSchema)
export type Bookmark = z.infer<typeof BookmarkSchema>
